import { useResetRecoilState } from 'recoil';
import { useFieldBase } from './useField';
export function useSelectField(props) {
    // get base props of validation fields
    const [baseProps, saveState] = useFieldBase(props);
    const resetState = useResetRecoilState(props.atom);
    return {
        ...baseProps,
        onChange: (value) => value === null ? resetState() : saveState(value),
    };
}
// TODO: for backwards compatibility, can be removed once all hooks are renamed
export const useValidationSelectField = useSelectField;
